<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
        </li>
      </ul>
    </ul>
    <div class="title-row-flex-both-end">
      <h1 class="main-title">{{langObj ? langObj?.OEEDashBoard : ('OEEDashBoard' | translate)}}</h1>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  <form [formGroup]="oeeDashboardForm">
    <div class="content-top-row content-top-row-order-processing">
      <!-- GROUP -->
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <!-- <mat-label>Status</mat-label> -->
        <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)"
          placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
            (filteredReturn)="filteredGroups = $event"></mat-select-filter>
          <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
            {{group.EG_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)"
          placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
            (filteredReturn)="filteredPlants = $event"></mat-select-filter>
          <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
            {{plant.PT_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="line" (selectionChange)="onChangeLine($event)"
          placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
            (filteredReturn)="filteredLines = $event"></mat-select-filter>
          <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
            {{line.PL_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="unit" placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}"
          panelClass="testClass" name="unit" (selectionChange)="onSubmit()">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
            (filteredReturn)="filteredUnits = $event"></mat-select-filter>
          <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
            {{unit.PU_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Dropdown -->
    <div class="content-top-row content-top-row-order-processing">
      <div class="inputField">
        <nz-date-picker class="calender-input" id="startPicker" formControlName="dateStart" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
        <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>
      </div>
      <div class="inputField">
        <nz-date-picker class="calender-input" id="endPicker" formControlName="dateEnd" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
        <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>
      </div>
      <div class="btn-position">
        <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
          (click)="onSubmit()" tooltipPosition="top">
          <img src="assets/images/search.png" alt="" width="20px" height="20px">
        </button>
      </div>

      <!-- <div class="d-flex" style="margin: 10px;">
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="today();showPhase(1)" [class.phase-active]="activeButton === 1"
            matTooltipClass="custom-tooltip" matTooltip="Today(Current Shift)">T</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="yesterday();showPhase(2)" [class.phase-active]="activeButton === 2"
            matTooltipClass="custom-tooltip" matTooltip="Yesterday(Last Shift)">1D</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastWeek();showPhase(3)" [class.phase-active]="activeButton === 3"
            matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastMonth();showPhase(4)" [class.phase-active]="activeButton === 4"
            matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
        </div>
      </div> -->

      <div class="d-flex" style="margin: 10px;">
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="today();showPhase(1)" [class.phase-active]="activeButton === 1"
            matTooltipClass="custom-tooltip" matTooltip="Current Shift">CS</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="yesterday();showPhase(2)" [class.phase-active]="activeButton === 2"
            matTooltipClass="custom-tooltip" matTooltip="Last Shift">LS</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="yesterdayFullDay();showPhase(3)" [class.phase-active]="activeButton === 3"
            matTooltipClass="custom-tooltip" matTooltip="Yesterday">1D</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastWeek();showPhase(4)" [class.phase-active]="activeButton === 4"
            matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastMonth();showPhase(5)" [class.phase-active]="activeButton === 5"
            matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
        </div>
      </div>
    </div>

    <div class="card-wrapper-list production-db">
      <div class="card-item card-item-five">
        <div class="card">
          <o3-percentage-graph [barProperties]="capacityUtilizationAnalysis"></o3-percentage-graph>
          <p class="graph-title">{{langObj ? langObj?.CapacityUtilization : ('CapacityUtilization' | translate)}}</p>
        </div>
      </div>
      <div class="card-item card-item-five">
        <div class="card">
          <o3-percentage-graph [barProperties]="oeeAnalysis"></o3-percentage-graph>
          <p class="graph-title">{{langObj ? langObj?.OEE : ('OEE' | translate)}}</p>
        </div>
      </div>

      <div class="card-item card-item-five-group">
        <div class="card">

          <o3-percentage-graph [barProperties]="availabilityAnalysis"></o3-percentage-graph>
          <p class="graph-title filter-btn" matTooltip="Pareto Dashboard" (click)="navigateToParetoDashboard()">
            {{langObj ? langObj?.Availability :
            ('Availability' |
            translate)}}</p>
        </div>
      </div>
      <div class="card-item card-item-five-group">
        <div class="card">

          <o3-percentage-graph [barProperties]="performanceAnalysis"></o3-percentage-graph>
          <p class="graph-title">{{langObj ? langObj?.Performance : ('Performance' | translate)}}</p>
        </div>
      </div>
      <div class="card-item card-item-five-group">
        <div class="card">

          <o3-percentage-graph [barProperties]="qualityAnalysis"></o3-percentage-graph>
          <p class="graph-title filter-btn" matTooltip="Quality Grade Analysis"
            (click)="navigateToQualityGridAnalysis()">{{langObj ? langObj?.Quality : ('Quality'
            |
            translate)}}</p>
        </div>
      </div>
    </div>

    <!-- Card -->
    <div class="menu-card-group">
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.TotalAvailableTime : ('TotalAvailableTime' | translate)}}</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{AvailableHours}}</span></p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{AvailableHours * 60 | number :
            '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
        </div>
      </div>
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.ShutdownHours : ('ShutdownHours' | translate)}}</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{ShutdownHours}}</span></p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{ShutdownHours * 60 | number :
            '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
        </div>
      </div>
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.PlannedWorkingTime : ('PlannedWorkingTime' | translate)}}</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{PlannedHours}}</span></p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{PlannedHours * 60 | number :
            '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
        </div>
      </div>


    </div>
    <div class="menu-card-group">
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.TotalDowntime : ('TotalDowntime' | translate)}}(PTD+UPTD)</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{totalPlannedDowntime | number :
            '1.2-2'}}</span>
        </p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{totalPlannedDowntime * 60 |
            number : '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
        </div>
      </div>
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.PlannedDowntime : ('PlannedDowntime' | translate)}}</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{PlannedDowntime}}</span>
        </p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{PlannedDowntime * 60 |
            number : '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
        </div>
      </div>

      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.UnplannedDowntime : ('UnplannedDowntime' | translate)}}</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{UnplannedDowntime}}</span>
        </p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{UnplannedDowntime * 60 |
            number : '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
        </div>
      </div>

    </div>

    <div class="menu-card-group">
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.TotalRunningHours : ('TotalRunningHours' | translate)}}</p>
        <p class="data-text  small-data-text">In Hrs: <span class="data-text">{{RunningHourse}}</span></p>
        <p class="data-text  small-data-text">In Mins:<span class="data-text">{{RunningHourse * 60 | number :
            '1.2-2'}} </span></p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
        </div>
      </div>
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.IdealProduction : ('IdealProduction' | translate)}}</p>
        <p class="data-text">
          {{idealProduction | number : '1.2-2'}}
          <span class="data-text small-data-text"></span>
        </p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
        </div>
      </div>
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.GrossProduction : ('GrossProduction' | translate)}}</p>
        <p class="data-text">
          {{GrossProduce | number : '1.2-2'}}
          <span class="data-text small-data-text"></span>
        </p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
        </div>
      </div>

    </div>

    <div class="menu-card-group">
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.NetProduction : ('NetProduction' | translate)}}</p>
        <p class="data-text">
          {{netProduction | number : '1.2-2'}}
          <span class="data-text small-data-text"></span>
        </p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
        </div>
      </div>
      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.QualityWaste : ('QualityWaste' | translate)}}</p>
        <p class="data-text">
          {{Waste | number : '1.2-2'}}
          <span class="data-text small-data-text"></span>
        </p>
        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
        </div>
      </div>

      <div class="menu-card-item mat-card-height">
        <p class="title-text">{{langObj ? langObj?.Waste : ('Waste' | translate)}}(KG)</p>
        <p class="data-text">
          {{wasteKG | number : '1.2-2'}}
          <span class="data-text small-data-text"></span>
        </p><br><span></span>

        <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
          <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
        </div>
      </div>

    </div>
    <div></div>

    <div class="chart-group">
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.OEELosses : ('OEELosses' | translate)}}</div>
        <div [chart]="chartMonthlyOeeDrill"></div>
      </div>
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.OutputLosses : ('OutputLosses' | translate)}}</div>
        <div [chart]="chartOutputLossWaterfall"></div>
      </div>
    </div>

    <!-- Charts  [plugins]="barChartPluginsMonthlyOEE" // add later-->
    <div class="chart-group">
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.OEETrend : ('OEETrend' | translate)}}</div>
        <div [chart]="chartMonthlyOeeTrend"></div>
      </div>
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.VolumeOutput : ('VolumeOutput' | translate)}}</div>
        <div [chart]="chartMonthlyOutput"></div>
      </div>
    </div>
  </form>
  <!-- list -->
  <section>
    <div class="example-button-row">
      <button type="button" class="btn btn-success" (click)="csvExport()" style="margin-top: 30px;"><img
          src="assets/images/csv-file-format.png"></button>
      <button type="button" class="btn btn-success" (click)="excelExport()"
        style="margin-top: 30px; margin-left: 10px;"><i class="fa fa-file-excel-o icon-white"
          aria-hidden="true"></i></button>
    </div>
  </section>
  <mat-card-content>
    <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
      [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" [pagination]="true"
      [paginationPageSize]="10">
    </ag-grid-angular>
  </mat-card-content>
</div>